@use '@/styles/tokens' as *;

.content {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  background: var(--surface-card);
}

.header {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 24px 16px;
  background: var(--surface-page);
  overflow: hidden;
}

.title {
  margin: 0;
  font-family: $font-family-heading;
  font-size: $font-size-2xl;
  font-weight: $font-weight-regular;
  letter-spacing: -0.02em;
  color: var(--text-primary);
  z-index: 1;
}

.pattern {
  pointer-events: none;
  user-select: none;
  position: absolute;
  inset-inline: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9;
  z-index: 0;
}

.close {
  position: absolute;
  top: 16px;
  inset-inline-end: 16px;
  z-index: 1;
}

.body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px 24px;
}

.footerCenter {
  justify-content: center;
  background: var(--surface-page);
}

.danger {
  --ant-color-primary: var(--status-danger-strong);
  background: var(--status-danger-strong) !important;
  border-color: var(--status-danger-strong) !important;
  color: var(--text-inverse) !important;
}

.form {
  display: contents;
}

.footerRegion {
  flex: 0 0 auto;
}
